import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Organizing from '@/components/organizing'
import Committee from '@/components/committee'
import Committee1 from '@/components/committee1'
import Session from '@/components/session'
import Submissions from '@/components/submissions'
import Visa from '@/components/visa'
import Travel from '@/components/travel'
import Contact from '@/components/contact'
import Reg from '@/components/reg'
import Login from '@/components/login'
import LoginThen from '@/components/loginThen'
import Register from '@/components/register'
import traveltwo from '@/components/traveltwo'
import hotel from '@/components/hotel'
import letter from '@/components/letter'
import submissionUpload from '@/components/submissionUpload'
import sponsors from '@/components/sponsors'
import pay from '@/components/pay'
import payzh from '@/components/payzh'
import submissionUploadzh from '@/components/submissionUploadzh'
import LoginThenzh from '@/components/LoginThenzh'
import loginzh from '@/components/loginzh'
import submissRegistration from '@/components/submissRegistration'
import submissRegistrationzh from '@/components/submissRegistrationzh'
import registerzh from '@/components/registerzh'
import program from '@/components/program'
import here from '@/components/here'
import local from '@/components/local'
import supporting from '@/components/supporting'
import awards from '@/components/awards'
import accommodation from '@/components/accommodation'


Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'index',
		component: Index,
	}, {
		path: '/submissRegistration',
		name: 'submissRegistration',
		component: submissRegistration
	}, {
		path: '/local',
		name: 'local',
		component: local
	}, {
		path: '/awards',
		name: 'awards',
		component: awards
	}, {
		path: '/supporting',
		name: 'supporting',
		component: supporting
	},
	{
		path: '/program',
		name: 'program',
		component: program
	}, {
		path: '/registerzh',
		name: 'registerzh',
		component: registerzh
	}, {
		path: '/submissRegistrationzh',
		name: 'submissRegistrationzh',
		component: submissRegistrationzh
	}, {
		path: '/organizing',
		name: 'organizing',
		component: Organizing
	}, {
		path: '/committee',
		name: 'committee',
		component: Committee
	}, {
		path: '/committee1',
		name: 'committee1',
		component: Committee1
	}, {
		path: '/session',
		name: 'session',
		component: Session
	}, {
		path: '/submissions',
		name: 'submissions',
		component: Submissions
	}, {
		path: '/visa',
		name: 'visa',
		component: Visa
	}, {
		path: '/travel',
		name: 'travel',
		component: Travel

	}, {
		path: '/contact',
		name: 'contact',
		component: Contact
	}, {
		path: '/reg',
		name: 'reg',
		component: Reg
	}, {
		path: '/register',
		name: 'register',
		component: Register
	}, {
		path: '/login',
		name: 'login',
		component: Login
	}, {
		path: '/loginThen',
		name: 'loginThen',
		component: LoginThen
	},
	{
		path: '/hotel',
		name: 'hotel',
		component: hotel
	}, {
		path: '/traveltwo',
		name: 'traveltwo',
		component: traveltwo
	}, {
		path: '/submissionUpload',
		name: 'submissionUpload',
		component: submissionUpload
	}, {
		path: '/sponsors',
		name: 'sponsors',
		component: sponsors
	}, {
		path: '/pay',
		name: 'pay',
		component: pay
	}, {
		path: '/payzh',
		name: 'payzh',
		component: payzh
	}, {
		path: '/submissionUploadzh',
		name: 'submissionUploadzh',
		component: submissionUploadzh
	}, {
		path: '/LoginThenzh',
		name: 'LoginThenzh',
		component: LoginThenzh
	}, {
		path: '/loginzh',
		name: 'loginzh',
		component: loginzh
	}, {
		path: '/here',
		name: 'here',
		component: here
	}, {
		path: '/accommodation',
		name: 'accommodation',
		component: accommodation
	}
	],
})


// WEBPACK FOOTER //
// ./src/router/index.js